import {useDispatch, useSelector} from 'Provider';
import React, {useCallback} from 'react';

import DateSelector from 'components/DateSelector';
import {OffersActions} from 'store/offers/offers.reducer';
import {
  availableFiltersSelector,
  selectedEndDateSelector,
  selectedStartDateSelector,
} from 'store/offers/offers.selectors';

const ConnectedFilterDateSelector: React.FC = () => {
  const dispatch = useDispatch();

  const setStartDate = useCallback(
    (date: string | undefined) => {
      dispatch(OffersActions.setStartDate(date));
    },
    [dispatch]
  );

  const setEndDate = useCallback(
    (date: string | undefined) => {
      dispatch(OffersActions.setEndDate(date));
    },
    [dispatch]
  );

  const selectedStartDate = useSelector(selectedStartDateSelector);
  const selectedEndDate = useSelector(selectedEndDateSelector);
  const availableFilters = useSelector(availableFiltersSelector);
  if (availableFilters.endDate === availableFilters.startDate) {
    return <></>;
  } else {
    return (
      <DateSelector
        startDate={selectedStartDate}
        endDate={selectedEndDate}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
        availableEndDate={availableFilters.endDate}
        availableStartDate={availableFilters.startDate}
      />
    );
  }
};

export default ConnectedFilterDateSelector;
